import { createActionTypes } from "utils/action/actionTypes";

export const FETCH_UPTIME_REPORT = createActionTypes('FETCH_UPTIME_REPORT');
export const DOWNLOAD_UPTIME_REPORT = createActionTypes('DOWNLOAD_UPTIME_REPORT');